import React, { useState } from "react";
import moment from 'moment';

import { Dialog, DialogContent, Button, IconButton, AppBar, Toolbar, Typography, Divider } from "@mui/material";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LoaderNew from "../../../common/LoaderNew";

import Accordeon from "../../../common/Accordeon";
import YahooRedirect from "../../../common/UserTutorialComponents/YahooRedirect";
import OutlookRedirect from "../../../common/UserTutorialComponents/OutlookRedirect";
import GmailRedirect from "../../../common/UserTutorialComponents/GmailRedirect";
import MicrosoftRedirect from "../../../common/UserTutorialComponents/MicrosoftRedirect";
import SylectusRedirect from "../../../common/UserTutorialComponents/SylectusRedirect";

const OnboardingDialog = ({
  open,
  onClose,
  classes,
  arrowRight,
  settingsIcon,
  gmailECMEmail,
  runGmailAuthBtn,
  verificationMessage,
  revokeGmailRedirect,
  autogeneratedMWEmail,
  redirectSetupTestForm,
  gmailECMEmailAuthorized,
  verificationEmailCreationTime
}) => {
  const [step, setStep] = useState(0);
  const [previousStep, setPreviousStep] = useState(null);
  const [isOpenedGmailManual, setOpenedGmailManual] = useState(false);
  const [loadingRevokeBtn, setLoadingRevokeBtn] = useState(false);

  const handleNext = (nextStep) => {
    setPreviousStep(step);
    setStep(nextStep);
  };

  const handleBack = () => {
    if (step === 8 || step === 9) {
      setStep(previousStep);
    } else if ([5, 6, 7].includes(step)) {
      setStep(2);
    } else if (step === 2) {
      setStep(0);
    } else if (step === 3 || step === 4) {
      setStep(0);
    } else {
      setStep((prevStep) => Math.max(prevStep - 1, 0));
    }
  };

  const helpText = <div className={classes.mb20}> 
    <Divider light className={`${classes.mt20} ${classes.mb20}`}/>
    <div className={classes.alignCenter}>
      <InfoOutlinedIcon className={`${classes.mr10}`} style={{ color: '#347CFF', fontSize: 16, pointerEvents: 'none' }}/>
      <span style={{ fontSize: 12 }}>If you have any issues following the instruction and need help or have questions, contact our support team via chat at the right bottom of the page or by email <i>support@milkyweb.net</i></span>     
    </div>
  </div>;

  const testRedirect = <div className={classes.mb20}> 
    <Divider light className={`${classes.mt20} ${classes.mb20}`}/>
    <div className={classes.p10}>
      <span>Did you do all steps above but see that redirecting not started? You can check redirect: </span>
      <div className={`${classes.mt10}`} style={{ textAlign: "center" }}>
        <Button className={`${classes.actionBtn}`} onClick={() => handleNext(8)} sx={{ mt: 2 }}>
          Test redirect
          <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
        </Button>
      </div>
    </div>
  </div>;

  const verificationMess = <div>{verificationMessage ?
    <div className={`${classes.mt10} ${classes.mb10}`}>
      {/* <div className={`${classes.descriptionFont}`} style={{ marginBottom: '5px' }}>
        <span>Your verification email. Use it to continue setting up emails forwarding process:</span>
      </div> */}
      <div className={`${classes.p20}`} style={{ backgroundColor: '#FFFBB8', border: '1px dashed #347CFF' }}>
        {verificationEmailCreationTime ? <span style={{ fontSize: 11 }}>{moment(verificationEmailCreationTime).format('HH:mm, dddd, MMM DD, YYYY')}</span> : null}
        {/* <strong className={`${classes.descriptionFont} ${classes.mb20}`}>Please, allow automatic forwarding:</strong> */}
        <div className={`${classes.mt20}`} style={{ fontSize: 11 }}>
          <div dangerouslySetInnerHTML={{ __html: verificationMessage }}/>
        </div>
      </div>
    </div>
    : 
    <div
      className={`${classes.mt10} ${classes.mb10} ${classes.p10} ${classes.descriptionFont}`}
      style={{ backgroundColor: '#FFFBB8', border: '1px dashed #AFAECF' }}
    >
      <i style={{ fontWeight: 600 }}>Here will appear a verification email from your provider.</i>
      <br></br>
      <i>Follow the instructions in this email to complete the redirect setup.</i>
    </div>
  }</div>;

  const soleraIcon = <div className={classes.mr20} style={{ width: '18px', display: 'flex' }}>
    <img
      alt="Sylectus"
      src="/images/sylectus.svg"
      style={{ height: '18px' }}
    />
  </div>;

  const gmailIcon = <div className={classes.mr20} style={{ width: '15px', display: 'flex' }}>
    <img
      alt="Gmail"
      src="/images/gmail.svg"
      style={{ height: '15px' }}
    />
  </div>;

  const yahooIcon = <div className={classes.mr10} style={{ width: '18px', display: 'flex' }}>
    <img
      alt="Yahoo"
      src="/images/yahoo.png"
      style={{ height: '18px' }}
    />
  </div>;

  const outlookIcon = <div className={classes.mr10} style={{ width: '18px', display: 'flex' }}>
    <img
      alt="Outlook"
      src="/images/outlook.png"
      style={{ height: '18px' }}
    />
  </div>;

  const microsoftIcon = <div className={classes.mr10} style={{ width: '18px', display: 'flex' }}>
    <img
      alt="Microsoft"
      src="/images/microsoft-365.svg"
      style={{ height: '18px' }}
    />
  </div>;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" style={{ top: 0, bottom: 'unset' }}
      sx={{
        '& .MuiToolbar-root': {
          paddingLeft: '25px',
          paddingRight: '10px',
        },
        '& .MuiDialog-root': {
          overflowY: 'visible',
        },
        '& .MuiPaper-root': { 
          borderRadius: '10px',
          backgroundColor: "#ffff", 
          fontSize: 14,
          maxHeight: 'calc(100vh - 100px)',
          margin: 0,
          width: '800px',
          top: '50px',
        },
        '& .MuiDialogContent-root': {
          padding: '5px 25px 10px',
          overflowY: 'auto'
        }
      }}
    >
      <AppBar position="static" sx={{ backgroundColor: "transparent", boxShadow: "none", padding: '20px 10px 0' }}>
        <Toolbar className={classes.spaceBetween} style={{ minHeight: '36px' }}>
          <div className={classes.alignStart}>
            <div style={{ height: '36px' }}>
              {step > 0 && (
                <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="back" sx={{ marginRight: '20px', backgroundColor: '#fff' }}>
                  <ArrowBackIcon />
                </IconButton>
              )}
            </div>

            <div style={{ paddingTop: '5px', color: '#1B1920' }} className={classes.alignStartColumn}>
              <h4>
                {step === 0 ?
                    'Choose your loads source'
                  : step === 1 ?
                    'Choose Loadboard provider you use'
                  : step === 2 ?
                    'Choose the email provider you use to receive loads'
                  : step === 3 ?
                    <div className={classes.alignCenter}>
                      {soleraIcon}
                      <span>Solera orders forwarding instruction</span>
                    </div>
                  : step === 4 ?
                    <div className={classes.alignCenter}>
                      {gmailIcon}
                      <span>Gmail account inbox forwarding instruction</span>
                    </div>
                  : step === 5 ?
                    <div className={classes.alignCenter}>
                      {yahooIcon}
                      <span>Yahoo account inbox forwarding instruction</span>
                    </div>
                  : step === 6 ?
                    <div className={classes.alignCenter}>
                      {outlookIcon}
                      <span>Outlook account inbox forwarding instruction</span>
                    </div>
                  : step === 7 ?
                    <div className={classes.alignCenter}>
                      {microsoftIcon}
                      <span>Microsoft 360 account inbox forwarding</span>
                    </div>
                  : step === 8 ?
                  'Check redirect'
                  : step === 9 ?
                  'Alternative set up'
                : null}
              </h4>

              {step <= 2 || step === 9 ?
                <span className={classes.mt10}>
                  {step === 0 ?
                    'Ensure all your loads are automatically captured by connecting your inboxes and loadboards to Milkyweb. You can add multiple sources for a complete workflow'
                  : step === 1 ?
                    'You can connect as many loadboards as you have and need'
                  : step === 2 ?
                    `Set up email forwarding in your provider's settings to send load emails directly to Milkyweb. Follow our step-by-step guide for easy setup`
                  : step === 5 || step === 6 || step === 7 ?
                    `Follow our step-by-step guide for easy setup`
                  : step === 9 ?
                    `We've generated a unique email address for your account. Use this address to set up forwarding from any source. This way, Milkyweb will receive and process your loads automatically.`
                  : null}
                </span>
              : null}
            </div>
          </div>

          <div style={{ alignSelf: 'baseline' }}>
            <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close" sx={{ backgroundColor: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </div>
          
        </Toolbar>
      </AppBar>

      <DialogContent>
        {step === 0 && (
          <div>
            {/* <div>
              <span>Set up a redirect from your work email or Loadboard to the Milkyweb</span>
            </div> */}
            <div className={`${classes.alignStart} ${classes.mt20} ${classes.mb20}`}>
              {/* <Button className={`${classes.actionBtn}`} variant="contained" color="primary" onClick={() => handleNext(1)} sx={{ m: 1 }}>
                Connect Loadboard
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button> */}
              <Button className={`${classes.mr20} ${classes.actionBtn}`} onClick={() => handleNext(4)} sx={{ mt: 2, m: 1 }}>
                {gmailIcon}
                Gmail
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ fontSize: 16 }}/>
              </Button>
              
              <Button className={`${classes.mr10} ${classes.actionBtn}`} onClick={() => handleNext(3)} sx={{ mt: 2 }}>
                {soleraIcon}
                Solera
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{  fontSize: 16 }}/>
              </Button>
              
              <Button className={`${classes.mr10} ${classes.actionBtn}`} onClick={() => handleNext(2)} sx={{ m: 1 }}>
                Other Email inbox providers
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ fontSize: 16 }}/>
              </Button>
              <Button className={`${classes.mr10} ${classes.actionBtn}`} onClick={() => handleNext(9)} sx={{ mt: 2, m: 1 }}>
                Other
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ fontSize: 16 }}/>
              </Button>
            </div>
            {/* <div className={classes.mb}>
              <Divider light className={`${classes.mt20} ${classes.mb20}`}/>
              <span>⚠️ We recommend sending loads from load boards directly to Milkyweb to avoid mailbox <a href="https://support.google.com/a/answer/166852?hl=en" target="_blank" rel="noreferrer">forwarding limit<OpenInNewRoundedIcon className={classes.iconInfo}/></a></span>
            </div> */}
          </div>
        )}
        {step === 1 && (
          <div>
            <div className={`${classes.mt20} ${classes.mb10}`} style={{ textAlign: "center" }}>
              <Button className={`${classes.mr20} ${classes.actionBtn}`} onClick={() => handleNext(3)} sx={{ mt: 2 }}>
                {soleraIcon}
                Solera
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button>
              <Button className={`${classes.mr20} ${classes.actionBtn}`} onClick={() => handleNext(9)} sx={{ mt: 2}}>
                Other
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div>
            <div className={`${classes.mt20} ${classes.mb20}`} style={{ textAlign: "center" }}>
              <Button className={classes.actionBtn} onClick={() => handleNext(5)} sx={{ mt: 2, m: 1 }}>
                {yahooIcon}
                Yahoo
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button>
              <Button className={classes.actionBtn} onClick={() => handleNext(6)} sx={{ mt: 2, m: 1 }}>
                {outlookIcon}
                Outlook
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button>
              <Button className={classes.actionBtn} onClick={() => handleNext(7)} sx={{ mt: 2, m: 1 }}>
                {microsoftIcon}
                Microsoft 360
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button>
              <Button className={classes.actionBtn} onClick={() => handleNext(9)} sx={{ mt: 2, m: 1 }}>
                Other
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button>
            </div>
            {/* <div className={classes.mt20} style={{ textAlign: "center" }}>
              <Button variant="contained" color="warning" className={classes.actionBtn} onClick={() => handleNext(9)} sx={{ mt: 2, m: 1 }}>
                Other
                <ArrowForwardIosRoundedIcon className={classes.ml10} style={{ color: '#4c4c4c', fontSize: 16 }}/>
              </Button>
            </div> */}
          </div>
        )}

        {step === 4 && (
          <div className={classes.mt10}>
            {runGmailAuthBtn ?
              <div className={classes.mt20}>
                {gmailECMEmailAuthorized ?
                  <div className={`${classes.spaceBetween} ${classes.actionBtn} ${classes.ml10}`} style={{ width: 'fit-content', backgroundColor: '#fff', padding: '5px 8px 5px 15px', borderRadius: '20px' }}>
                    <div className={`${classes.alignCenter} ${classes.mr30}`}>
                      <span className={classes.mr5} style={{ color: '#4c4c4c' }}>{gmailECMEmail}</span>
                      <CheckCircleOutlinedIcon style={{ color: '14AA09', fontSize: 16, pointerEvents: 'none' }}/>
                    </div>
                    <Button
                      className={`${classes.actionBtn} ${classes.thirdSmallBtn}`}
                      onClick={() => {
                        setLoadingRevokeBtn(true);
                        revokeGmailRedirect(() => {
                          setTimeout(() => {
                            setLoadingRevokeBtn(false);
                          }, 700);
                        });
                      }}
                      sx={{ mt: 2 }}
                    >
                      {loadingRevokeBtn ?
                        <LoaderNew style={{ height: '15px' }}/>
                      : 'Revoke access'}
                    </Button>
                  </div>
                : <div className={`${classes.alignStart} ${classes.ml10}`}>
                    <div className={classes.column}>
                      <span className={`${classes.mb20} ${classes.mr10}`}>
                        Gmail authentication is currently awaiting Google's approval.<br/> Select the <strong>'Advanced'</strong> option when connecting to mlkwb.ai on the next step,<br/> as demonstrated =&gt;
                      </span>
                      <Button className={classes.actionBtn} style={{ color: '#347CFF' }} onClick={runGmailAuthBtn} sx={{ mt: 2 }}>
                        + Gmail account inbox
                      </Button>
                    </div>
                    <div>
                      <img
                        style={{ height: '320px', border: '1px solid #e8e8f7' }}
                        src="/images/google_auth_access.gif"
                        alt="google to mw access"
                      />
                    </div>
                  </div>
                  }
              </div>
            : null}

            <Divider light className={`${classes.mt20} ${classes.mb20}`}/>

            <div className={classes.mt10}>
              <Accordeon
                stylesCover={{ width: 'fit-content', paddingRight: '15px', borderRadius: '20px', backgroundColor: 'transparent' }}
                isOpened={isOpenedGmailManual}
                toggleAccordeon={() => setOpenedGmailManual((prevState) => !prevState )}
                title={'Manual redirect setup'}
                titleRightCol={' '}
              >
                <div className={classes.p10}>
                  <GmailRedirect
                    classes={classes}
                    arrowRight={arrowRight}
                    settingsIcon={settingsIcon}
                    verificationMess={verificationMess}
                    autogeneratedMWEmail={autogeneratedMWEmail}
                  />
                </div>
                {testRedirect}
              </Accordeon>
            </div>

            {helpText}
          </div>
        )}

        {step === 5 && (
          <div className={classes.p10} style={{ backgroundColor: '#fff' }}>
            <YahooRedirect
              classes={classes}
              arrowRight={arrowRight}
              settingsIcon={settingsIcon}
              verificationMess={verificationMess}
              autogeneratedMWEmail={autogeneratedMWEmail}
            />

            {testRedirect}
            {helpText}
          </div>
        )}
        {step === 6 && (
          <div className={classes.p10} style={{ backgroundColor: '#fff' }}>
            <OutlookRedirect
              classes={classes}
              arrowRight={arrowRight}
              settingsIcon={settingsIcon}
              autogeneratedMWEmail={autogeneratedMWEmail}
            />

            {testRedirect}
            {helpText}
          </div>
        )}
        {step === 7 && (
          <div className={classes.p10} style={{ backgroundColor: '#fff' }}>
            <MicrosoftRedirect
              classes={classes}
              arrowRight={arrowRight}
              settingsIcon={settingsIcon}
              autogeneratedMWEmail={autogeneratedMWEmail}
            />

            {testRedirect}
            {helpText}
          </div>
        )}
        {step === 8 && (
          <div>
            {redirectSetupTestForm()}
          </div>
        )}
        {step === 3 && (
          <div className={classes.p10} style={{ backgroundColor: '#fff' }}>
            <SylectusRedirect
              classes={classes}
              arrowRight={arrowRight}
              settingsIcon={settingsIcon}
              autogeneratedMWEmail={autogeneratedMWEmail}
            />
          </div>
        )}
        {step === 9 && (
          <div>
            <div className={`${classes.alignJustifyCenter} ${classes.p20}`}>
              <strong>{autogeneratedMWEmail()}</strong> 
            </div>
            {helpText}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingDialog;

//If the loads source you use is missing in the onboarding instruction, p
